// extracted by mini-css-extract-plugin
module.exports = {"navNotificationBody":"NotificationList_navNotificationBody__wZwk9"};